import { bhsTokens } from '../tokens';
import type { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme: Theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[600]
        },
        outlined: {
          fontSize: bhsTokens.input.labelFontSize,
          lineHeight: '1.25rem',
          top: '50%',
          transform: 'translate(14px, -50%) scale(1)',
          '&.MuiInputLabel-sizeSmall': {
            fontSize: bhsTokens.input.labelFontSize,
            lineHeight: '1.25rem'
          },
          '&.MuiInputLabel-shrink': {
            background: theme.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6,
            top: 0,
            fontSize: bhsTokens.input.floatingLabelFontSize,
            lineHeight: '1.1rem',
            transform: 'translate(14px, -9px) scale(1)'
          }
        }
      }
    }
  };
}
